module.exports = __webpack_public_path__ + "media/images/certificate-lg-dd1b4fa52d2b9cd05582a6a6bbe70777.png";